import "./main.css";

import { mount } from "svelte";
import App from "./App.svelte";
import { completeDropboxAuth } from "./fs-dropbox-login";
import { completeOneDriveAuth } from "./fs-onedrive-login";
import { createUserIDAndIdentify } from "./user";
import { installDev } from "./dev";

installDev();

const path = location.pathname;
if (path == "/auth/dropboxlogin") {
  console.log("before completeDropboxAuth()");
  completeDropboxAuth();
} else if (path == "/auth/onedrivelogin") {
  console.log("before completeOneDriveAuth()");
  completeOneDriveAuth();
} else {
  createUserIDAndIdentify();
  let target = document.getElementById("app") as Element;
  const app = mount(App, {
    target: target,
  });
}
